import { componentFactory } from '@fusioncharts/core/src/lib';
let removeSets = function (parent, set) {
  let children = parent.getChildren(), // eslint-disable-line good-practices/no-single-usage-variable
    childArr,
    j,
    i;
  if (set && set.length) {
    for (i = set.length - 1; i > -1; i--) {
      childArr = children[set[i]];
      for (j = childArr && childArr.length - 1; j > -1; childArr[j].remove(), j--);
    }
  }
};
/**
 * function to  create dataset, groupmaneger.
 * assign dataset to group manager.
 **/
export default function (chart) {
  let jsonData = chart.getFromEnv('dataSource'),
    datasetsJSON = jsonData.dataset,
    connectorsJSON = jsonData.connectors,
    labels = jsonData.labels,
    canvas = chart.getChildren('canvas')[0], // eslint-disable-line good-practices/no-single-usage-variable
    vCanvas,
    datasetParent = vCanvas = canvas.getChildren('vCanvas')[0],
    setType = [],
    groupManager;
  labels && (labels = [labels]);
  if (!datasetsJSON && !connectorsJSON && !labels) {
    chart.setChartMessage();
    return;
  }
  componentFactory(vCanvas, chart.getDSGroupdef(), 'datasetGroup_dragNode');
  groupManager = vCanvas.getChildren('datasetGroup_dragNode');
  groupManager && (datasetParent = groupManager[0]);
  if (datasetsJSON && datasetsJSON.length) {
    componentFactory(datasetParent, chart.getDSdef('dragnode'), 'dataset', datasetsJSON.length, datasetsJSON);
  } else {
    setType.push('dataset');
  }
  if (connectorsJSON && connectorsJSON.length) {
    componentFactory(datasetParent, chart.getDSdef('connector'), 'connector', connectorsJSON.length, connectorsJSON);
  } else {
    setType.push('connector');
  }
  if (labels && labels.length) {
    componentFactory(datasetParent, chart.getDSdef('dragableLabels'), 'labels', labels.length, labels);
  } else {
    setType.push('labels');
  }
  setType.length && removeSets(datasetParent, setType);
}
